<div class="iframe-page-container">
	<h2 class="layout-heading">
		{{ pageTitle }}
	</h2>
	<div [ngClass]="{'hidden': !isIframeReady || !isCookieAuthenticated}" class="iframe-container">
		<iframe #portalIframe [src]="classicPortalIframeUrl | safe" id="portalIframe" title="classic portal">
		</iframe>
	</div>
</div>
